// EMERGENCY FIXES - FORCE ALL ISSUES TO BE RESOLVED IMMEDIATELY

document.addEventListener('DOMContentLoaded', function() {
    
    // 1. BREAST CANCER RIBBON REMOVED
    
    // 1. FORCE CART COUNT TO BE VISIBLE
    setTimeout(function() {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
            cartCount.style.display = 'flex';
            cartCount.style.visibility = 'visible';
            cartCount.style.opacity = '1';
            if (!cartCount.textContent || cartCount.textContent.trim() === '') {
                cartCount.textContent = '0';
            }
        }
    }, 100);
    
    // 2. FORCE PRODUCT IMAGES TO FILL CONTAINERS
    setTimeout(function() {
        const productImages = document.querySelectorAll('.product-image img, .product-card img');
        productImages.forEach(function(img) {
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'cover';
            img.style.objectPosition = 'center';
            img.style.display = 'block';
        });
        
        const productContainers = document.querySelectorAll('.product-image, .product-card .product-image');
        productContainers.forEach(function(container) {
            container.style.width = '100%';
            container.style.height = '300px';
            container.style.overflow = 'hidden';
            container.style.background = '#F4E6E6';
        });
    }, 200);
    
});
